export enum BodyOrientationEnum {
  Front = 1,
  Back = 2,
  Left = 3,
  Right = 4
}

export const BodyOrientationOptions = [
{ id: 1, label: 'Front' },
{ id: 2, label: 'Back' },
{ id: 3, label: 'Left' },
{ id: 4, label: 'Right' }
];
